var _style, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDragItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#A57F81;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.012,
    y: 0,
    className: "st0",
    width: 29,
    height: 29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 1,
    height: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragItem);
export default __webpack_public_path__ + "static/media/icon-drag-item.42a6ccc62534009571112005e2a4b83e.svg";
export { ForwardRef as ReactComponent };